import { Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { AdditionalHeader } from '../../../app/presentations/landing/landing';
import { GetCustParamResp } from './get-cust-param.type';
import { Observable } from 'rxjs';
import { PromoRepository } from '../../repositories/promo.repository';

@Injectable({
    providedIn: 'root'
})

export class GetCustParamUsecase implements UseCase<AdditionalHeader[], GetCustParamResp> {
    constructor(private readonly promoRepository: PromoRepository){};
    execute(header: AdditionalHeader[]): Observable<GetCustParamResp> {
        return this.promoRepository.GetCustParam(header);
    }
}